export default __webpack_public_path__ + "static/media/JASPE PIEL DE COBRA.58d81308.jpg";